module.exports = __webpack_public_path__ + "static/img/referrer4.400672d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referrer4.png
// module id = M9aI
// module chunks = 1